import { Component } from "@angular/core";
import { Meta } from "@angular/platform-browser";

@Component({
  templateUrl: "./verify-account-error.component.html",
  styleUrls: ["./verify-account-error.component.scss"],
})
export class VerifyAccountErrorComponent {
  constructor(meta: Meta) {
    meta.updateTag({
      name: "viewport",
      content: "width=device-width, initial-scale=1",
    });
  }

  continue(): void {
    window.location.href = "/";
  }
}
